import { useTheme } from "@mui/joy"
import { useMediaQuery } from "@mui/material";

export const isSmallToMidScreen = () => {
  const theme = useTheme()
  const smallToMid = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const small = useMediaQuery(theme.breakpoints.down("sm"));
  return smallToMid || small;
}